import { render, staticRenderFns } from "./DashboardWidgetTermine.vue?vue&type=template&id=1344e315&scoped=true"
import script from "./DashboardWidgetTermine.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetTermine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1344e315",
  null
  
)

export default component.exports